// libs
import { styled } from '@nykaa/ui-components';

export const Container = styled.div`
  min-height: 100vh;
`;

export const ImageContainer = styled.div`
  width: 100%;
  display: flex;
  height: max(100vh - 331px, 93.3333vw);
  max-height: 120vw;
  display: flex;
  overflow: hidden;
  ${({ theme }) => `
    margin: ${theme.spacing.spacing40} 0 ${theme.spacing.spacing60} 0;
  `}
`;

export const Image = styled.div`
  height: 100%;
  max-width: 90vw;
  flex: 0 0 auto;
  width: calc(max(100vh - 331px, 93.3333vw) * 0.75);
  ${({ theme }) => `
    background: ${theme.colors.surface20};
    margin-right: ${theme.spacing.spacing20};
  `}
`;

export const Tags = styled.div`
  height: 16px;
  width: 200px;
  ${({ theme }) => `
    background: ${theme.colors.surface20};
    margin: 0 ${theme.spacing.spacing80} ${theme.spacing.spacing60};
  `}
`;

export const Title = styled.div`
  height: 20px;
  width: 300px;
  ${({ theme }) => `
    background: ${theme.colors.surface20};
    margin: 0 ${theme.spacing.spacing80} ${theme.spacing.spacing20};
  `}
`;

export const SubTitle = styled.div`
  height: 20px;
  width: 250px;
  ${({ theme }) => `
    background: ${theme.colors.surface20};
    margin: 0 ${theme.spacing.spacing80} ${theme.spacing.spacing40};
  `}
`;

export const Rating = styled.div`
  height: 20px;
  width: 200px;
  ${({ theme }) => `
    background: ${theme.colors.surface20};
    margin: 0 ${theme.spacing.spacing80};
  `}
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  ${({ theme }) => `
    background: ${theme.colors.textOutline};
    margin: ${theme.spacing.spacing80} 0;
  `}
`;

export const SizeHeading = styled.div`
  height: 24px;
  width: 90px;
  ${({ theme }) => `
    background: ${theme.colors.surface20};
    margin: 0 ${theme.spacing.spacing80} ${theme.spacing.spacing50};
  `}
`;

export const Sizes = styled.div`
  display: flex;
  overflow: hidden;
  ${({ theme }) => `
    margin: 0 ${theme.spacing.spacing80};
  `}
`;

export const SizeOptions = styled.div`
  height: 34px;
  width: 52px;
  flex: 0 0 auto;
  ${({ theme }) => `
    background: ${theme.colors.surface20};
    border-radius: ${theme.borders.radius50};
    margin-right: ${theme.spacing.spacing40};
  `}
`;
